export default __webpack_public_path__ + "static/media/HaUyenTran.324ee5c5.webp";